/**
 * staffDashboardStore — Staff operational dashboard slice (Zustand).
 *
 *   GET /api/staff/dashboard
 *     ?recentPurchasesLimit&recentFailedEmailsLimit&examType
 */
import { apiRequest } from "./staffUtils";
import { toDisplayString } from "../../utils/toDisplayString";

export const staffDashboardInitialState = {
  staffDashboard: null,
  staffDashboardLoading: false,
  staffDashboardError: null,
};

/** Drop empty query values so strict enum params (examType) are never sent blank. */
function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query.set(key, String(value));
  });
  const qs = query.toString();
  return qs ? `?${qs}` : "";
}

export function createStaffDashboardActions(set, get) {
  return {
    // GET /api/staff/dashboard
    fetchStaffDashboard: async (params = {}) => {
      set({ staffDashboardLoading: true, staffDashboardError: null });
      try {
        const data = await apiRequest(get, `/api/staff/dashboard${buildQuery(params)}`);
        // The endpoint returns the payload directly; accept an envelope too so
        // the page keeps working if the API ever wraps it.
        const dashboard = data?.dashboard ?? data?.data ?? data;
        set({ staffDashboardLoading: false, staffDashboard: dashboard });
        return { success: true, dashboard };
      } catch (err) {
        const msg = toDisplayString(err.message, "Failed to load dashboard");
        set({ staffDashboardLoading: false, staffDashboardError: msg });
        return { success: false, error: msg };
      }
    },
  };
}

const staffDashboardActions = createStaffDashboardActions;
export default staffDashboardActions;
